import { tw_disableBtn } from "./util.js";

/* eslint-disable prettier/prettier */
class PDFHistory {
  constructor(options) {
    this.current = 0;
    this.list = [];
    this.previousVisitedBtn = options.previousVisitedBtn;
    this.nextVisitedBtn = options.nextVisitedBtn;
  }

  clear() {
    this.list = [];
    this.current = 0;
  }

  add(page) {
    this.list.push(page);
    this.current++;
    this.refreshButtons();
  }

  refreshButtons() {
    tw_disableBtn(this.previousVisitedBtn, this.current < 2);
    tw_disableBtn(this.nextVisitedBtn, this.current === this.list.length);
  }

  back() {
    this.current--;
    this.refreshButtons();
    return this.list[this.current - 1];
  }

  forward() {
    this.current++;
    this.refreshButtons();
    return this.list[this.current - 1];
  }
}

export { PDFHistory };
